export default __webpack_public_path__ + "static/media/vox-img-legacy-005.a78aa0c9.jpg";